import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-mortality',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './mortality.component.html',
    styleUrl: './mortality.component.scss'
})
export class MortalityComponent {
    @Input() mortality: any | null = null;
    @Input() placement: any | null = null;
    @Input() placementId: number | null = null;
    @Input() placementName: string | null = null;
    @Input() userName: string | null = null;
    @Input() farmId: number | null = null;
    @Input() farmHouseId: number | null = null;
    @Input() farmHouseName: string | null = null;
    @Input() partitionId: number | null = null;
    @Input() partitionName: string | null = null;
    @Input() numberOfChicks: number | null = null;
    @Input() typeId: number | null = null;
    @Input() typeName: string | null = null;
    @Input() age: number | null = null;
    @Input() date: string | Date | null = null;
    @Input() notes: string | null = null;
    @Input() birdCount: string | number | null = null;
    @Input() ageIndicator: string | null = null;

    constructor() {}
}
